module.exports = __webpack_public_path__ + "6fc8fde56808fcc54afa8982b0c28d18.svg";